const initialState = {
    featureloading: false,
    featureData : []
  };
  
  const featureStore = (state = initialState, action ) => {
      switch(action.type){
          case "FEATURELOADER": {
            return {...state, featureloading:action.response }
          }
          case "GET_FEATURELOADER": {
            return { ...state, featureData: action.response, featureloading:false };
          }
          case "UPDATE_FEATURE":{
            return { ...state, featureData: action.response, featureloading:false};
          }
          case "FEATUREFAIL":{
            return { ...state, featureloading: action.response };
          }
          default:
            return { ...state };
    }
  }
  
  export default featureStore;